/**
 * Layout: Floor plan
 * Slug: floor_plan
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.floor_plan-layout');

	layouts.forEach((layout) => {
		
	});
});
